/**
 * This converts an array of csv files to have utf-8 encoding by using
 * FileReader and readAsBinaryString.
 */
export default function convertCsvFilesToUtf8(files: File[]) {
  return Promise.all(
    files.map(
      (file) =>
        new Promise<File>((resolve, reject) => {
          const reader = new FileReader();

          reader.readAsBinaryString(file);
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              resolve(
                new File([reader.result], file.name, {
                  type: 'text/csv; charset=utf-8',
                }),
              );
            } else {
              reject();
            }
          };
        }),
    ),
  );
}
